// extracted by mini-css-extract-plugin
export default {"container_table":"WaitingAd_container_table__o67PV"};